import * as t from 'io-ts';
import { authorizedTo, id, meta } from '../..';
import { withFallback } from 'io-ts-types/lib/withFallback';

const DEFAULT_AUTHORIZED_TO = { view: false, update: false, delete: false };

export const optionValueCodec = t.type({
  id,
  label: t.string,
  value: t.union([t.string, t.null]),
  isActive: t.boolean,
});

export const recordCodec = t.type({
  id,
  name: t.string,
  optionValues: t.array(optionValueCodec),
  authorizedTo: withFallback(authorizedTo, DEFAULT_AUTHORIZED_TO),
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
});

export const detailCodec = t.type({
  name: withFallback(t.string, ''),
  optionValues: withFallback(t.array(optionValueCodec), []),
  authorizedTo: withFallback(authorizedTo, DEFAULT_AUTHORIZED_TO),
});

export const formCodec = t.type({
  name: t.string,
  optionValues: t.array(t.type({
    label: t.string,
    value: t.union([t.string, t.null]),
    isActive: t.boolean,
  })),
});

export type OptionSetRecord = t.TypeOf<typeof recordCodec>;
export type OptionSetDetail = t.TypeOf<typeof detailCodec>;
